/* eslint-disable no-underscore-dangle */
/* eslint-disable import/prefer-default-export */
import { GLOBAL } from 'saddlebag-browser';
import { logError } from 'saddlebag-logger';

const $window = GLOBAL.getWindow();
const { isCallback } = $window.__internal || {};

export const createUnhandledErrorHandler = () => {
  let sentErrors = 0;
  const errorMessages = [];
  const logSendThreshold = 10;
  return (message) => {
    if (
      sentErrors < logSendThreshold &&
      errorMessages.indexOf(message) === -1
    ) {
      logError({
        pageName: 'login',
        component: isCallback ? 'callback' : 'unhandled',
        message,
      });
      sentErrors += 1;
      errorMessages.push(message);
    }
  };
};
const unhandledErrorHandler = createUnhandledErrorHandler();

$window.onerror = unhandledErrorHandler;
$window.onunhandledrejection = (rejection) =>
  unhandledErrorHandler(String(rejection.reason));
